import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY } from '../utils/envVar';

const supabaseUrl = (
  SUPABASE_URL ??
  process.env.REACT_APP_SUPABASE_URL ??
  ''
).trim();
const supabaseKey = (
  SUPABASE_PUBLISHABLE_KEY ??
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY ??
  ''
).trim();

// Under Jest the env vars aren't provided and supabase calls are mocked, so
// only fail-fast on misconfiguration in real (dev/prod) runtimes. Throwing at
// import time otherwise makes this module - and everything that transitively
// imports it - impossible to load in tests.
const isTestEnv = process.env.NODE_ENV === 'test';

if (!supabaseUrl && !isTestEnv) {
  console.error('Missing REACT_APP_SUPABASE_URL environment variable');
  throw new Error(
    'Supabase URL is required. Please add REACT_APP_SUPABASE_URL to your .env file',
  );
}

if (!supabaseKey && !isTestEnv) {
  console.error(
    'Missing REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY environment variable',
  );
  throw new Error(
    'Supabase key is required. Please add REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY to your .env file',
  );
}

// Log configuration (without exposing the key)
if (process.env.NODE_ENV === 'development') {
  console.log('Supabase configuration:', {
    url: supabaseUrl,
    keyPresent: !!supabaseKey,
    keyLength: supabaseKey.length,
  });
}

// Dummy fallbacks keep createClient (which validates the URL) from throwing
// under test when the env vars are absent; supabase is mocked in tests.
export const supabase = createClient(
  supabaseUrl || 'http://localhost:54321',
  supabaseKey || 'test-anon-key',
  {
    accessToken: async () => {
      const token = window.localStorage.getItem('userToken');
      if (!token) {
        console.warn(
          'Supabase accessToken: no userToken found in localStorage',
        );
      }
      return token || '';
    },
    auth: {
      persistSession: false,
      autoRefreshToken: false,
    },
    global: {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  },
);
